import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const NUMS = [["max_branches_per_user", "Maximum branches per user (incl. main)"], ["max_pending_branches", "Max unpaid branches at once"],
  ["max_direct_per_branch", "Max paid direct referrals per branch"], ["network_visibility_depth", "Network visibility depth (levels)"],
  ["name_min_length", "Branch name min length"], ["name_max_length", "Branch name max length"]];
const BOOLS = [["enabled", "Branch creation enabled"], ["require_owner_active", "Owner's main branch must be active"],
  ["referral_requires_active_branch", "Referral links work only for active branches"], ["allow_cancel_pending", "Members may cancel unpaid branches"],
  ["refund_reverses_commissions", "Refunds reverse the activation's commissions"], ["notify_in_app", "Send in-app branch notifications"]];

export const AdminBranchSettings = ({ canEdit }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/settings/branches").then(({ data }) => setS(data)); }, []);
  if (!s) return <Loader2 className="w-5 h-5 animate-spin m-6" />;

  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/settings/branches", s); setS(data); toast.success("Branch settings saved"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
    setBusy(false);
  };

  return (
    <div className="bg-white rounded-2xl border border-[#FECACA] p-6 space-y-6 max-w-3xl" data-testid="admin-branch-settings">
      <div className="grid md:grid-cols-2 gap-4">
        {NUMS.map(([k, l]) => (
          <label key={k} className="text-sm"><span className="font-medium">{l}</span>
            <input type="number" min={1} disabled={!canEdit} value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="input-soft mt-1" data-testid={`branch-setting-${k}`} /></label>
        ))}
        <label className="text-sm"><span className="font-medium">Hamper product SKU used for activation</span>
          <input disabled={!canEdit} value={s.hamper_sku} onChange={(e) => setS({ ...s, hamper_sku: e.target.value })} className="input-soft mt-1" data-testid="branch-setting-hamper_sku" /></label>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        {BOOLS.map(([k, l]) => (
          <label key={k} className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" disabled={!canEdit} checked={!!s[k]} onChange={(e) => setS({ ...s, [k]: e.target.checked })} className="accent-[#DC2626]" data-testid={`branch-setting-${k}`} /> {l}
          </label>
        ))}
      </div>
      <p className="text-xs text-[#B91C1C]">The hamper price comes from the product in Products. Every change here is written to the audit log.</p>
      {canEdit ? <button disabled={busy} onClick={save} className="btn-primary" data-testid="branch-settings-save-btn">{busy ? "Saving…" : "Save settings"}</button>
        : <p className="text-xs">Only the super admin can change these settings.</p>}
    </div>
  );
};
